export default __webpack_public_path__ + "static/media/crisp1.5834ba26.png";